/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { getReviewPreviewData } from '../../../helpers/helper-methods';
import {
  reviewRatingsMap,
} from '../../../constans/model-maps';

import styles from './PropertyDetailsInfo.module.scss';

function PropertyDetailsInfo({
  propertyData,
  containerStyles,
  anchorsData,
  propertyId,
}) {
  const [previewData, setPreviewData] = useState(null);

  useEffect(() => {
    getReviewPreviewData(propertyId).then((resp) => {
      setPreviewData(resp);
    });
  }, [propertyId]);

  return (
    <div className={containerStyles}>
      {previewData?.description && (
        <div className={styles.borderedBlock}>
          <h2 className={`${styles.subtitle} t-600 uppercased-text`}>Description</h2>
          <p className={`${styles.text} t-500`}>{previewData.description}</p>
        </div>
      )}
      {
        previewData?.facilitiesAndActivitiesComment
          || previewData?.environmentalAndSocialComment ? (
            <div>
              {previewData?.facilitiesAndActivitiesComment && (
              <div className={styles.borderedBlock}>
                <h2 className={`${styles.infoBlockTitleComment} t-600 uppercased-text`}>{reviewRatingsMap.facilitiesAndActivitiesComment}</h2>
                <p className={`${styles.textComment} t-500`}>{previewData.facilitiesAndActivitiesComment}</p>
              </div>
              )}
              { /* previewData?.environmentalAndSocialComment && (
              <div className={styles.borderedBlock}>
                <h2 className={`${styles.infoBlockTitleComment} t-600 uppercased-text`}>{reviewRatingsMap.environmentalAndSocialComment}</h2>
                <p className={`${styles.textComment} t-500`}>{previewData.environmentalAndSocialComment}</p>
              </div>
              ) */}
            </div>
          )
          : null
      }
      {propertyData.environmentalDescription
        || propertyData.socialAndEthicalDescription ? (
          <div
            id={anchorsData.policies.id}
            className={styles.infoBlock}
          >
            <h2 className={styles.infoBlockTitle}>
              Environmental & Social
            </h2>
            <div className={styles.infoList}>
              {propertyData.environmentalDescription && (
              <div className={`${styles.infoListItem}`}>
                <p className={styles.infoBlockText}>
                  {propertyData.environmentalDescription}
                </p>
              </div>
              )}
              {
                /* propertyData.socialAndEthicalDescription && (
              <div className={`${styles.infoListItem}`}>
                <h2
                  className={`${styles.infoBlockSubtitle} uppercased-text t-600`}
                >
                  Social policies, projects and actions
                </h2>
                <p className={styles.infoBlockText}>
                  {propertyData.socialAndEthicalDescription}
                </p>
              </div>
              ) */}
            </div>
          </div>
        ) : null}
    </div>
  );
}

PropertyDetailsInfo.defaultProps = {
  foodImageStyles: '',
  containerStyles: '',
  anchorsData: {
    aboutUs: {
      id: null,
    },
    accessibilities: {
      id: null,
    },
    policies: {
      id: null,
    },
    transports: {
      id: null,
    },
    facilities: {
      id: null,
    },
    restaurants: {
      id: null,
    },
    roomServices: {
      id: null,
    },
  },
};

export default PropertyDetailsInfo;
